const isMoney = require('./isMoney');
const Lang = require('lang');
const ConversaoCambio = require('./ConversaoCambio');
const floatToMoney = require('../functions/floatToMoney');

exports.init = function ValidateForms() {

  /**
   * jQuery Validator defaults
   */
  $.validator.setDefaults({
    highlight: function (element) {
      $(element).closest('.form-group').addClass('has-error');
    },
    unhighlight: function (element) {
      $(element).closest('.form-group').removeClass('has-error');
    },
    errorElement: 'span',
    errorClass: 'help-block',
    ignore: ':hidden:not([class~=selectized]), :hidden > .selectized, .selectize-control .selectize-input input',
    invalidHandler: function () {
      $('.js-laravel-error-message').remove();
    },
    errorPlacement: function (error, element) {
      if (element.parent('.input-group').length) {
        error.insertAfter(element.parent());
      } else if (element.parent('.form-group').length) {
        error.appendTo(element.parent('.form-group'));
      } else {
        error.insertAfter(element);
      }
    }
  });

  /**
   * Validação para CPF
   */
  $.validator.addMethod('cpf', function (value, element) {
    return /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/.test(value);
  }, Lang.get('js/src/functions/ValidateForms.insert_valid_cpf'));

  /**
   * Validação para CPF
   */
  $.validator.addMethod('notEmpty', function (value, element) {
    return value.trim().length > 0;
  }, Lang.get('js/src/functions/ValidateForms.empty_field_message'));

  /**
   * Validação para CNPJ
   */
  $.validator.addMethod('cnpj', function (value, element) {
    return /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/.test(value);
  }, Lang.get('js/src/functions/ValidateForms.insert_valid_cnpj'));

  /**
   * Validação para Dinheiro
   */
  $.validator.addMethod('money', function (value, element) {
    return isMoney(value);
  }, Lang.get('js/src/functions/ValidateForms.money_validation_message'));

  /**
   * Validação para Dinheiro
   */
  $.validator.addMethod('negative-money', function (value, element) {
    return isMoney(value, true);
  }, Lang.get('js/src/functions/ValidateForms.money_validation_message'));

  /**
   * Validar despesas de cartões
   */
  let amount = '';
  let currency = '';
  $.validator.addMethod('expense-card-amount', function (value, element) {
    const transactionAmount = element.getAttribute('transaction-amount');

    currency = element.getAttribute('transaction-currency-iso');

    if (transactionAmount === null) {
      return true;
    }

    // Retirando . caso o valor for maior que 1000
    const validateAmount = value.replace('.', '');

    amount = floatToMoney(parseFloat(transactionAmount.replace(',', '.')).toFixed(2));

    return parseFloat(validateAmount.replace(',', '.')) <= parseFloat(transactionAmount.replace(',', '.'));
  }, function () {
    return Lang.get('js/src/functions/ValidateForms.expense_card_validation_message', {
      'amount': amount,
      'currency': currency
    })
  });

  /**
   * Validação para mesma moeda do relatorio
   */
  let isoMoedaRelatorio = '';
  let entidadeValidacao = '';
  $.validator.addMethod('mesmaMoedaRelatorio', function (value, element) {
    const form = element.form;
    const relatorioInput = form.querySelector('#idDespesa');

    // Se for uma despesa avulsa (sem relatório), ignorar a
    // verificação pois a despesa poderá ter qualquer moeda
    if (relatorioInput.value === '') {
      return true;
    }

    // Fazer requisição e retornar se é a mesma moeda do relatório escolhido
    const url = route('app.despesas.moeda-relatorio', { id: relatorioInput.value });

    let idMoeda = null;
    $.ajax({
      url: url,
      async: false,
      success: function (data) {
        if (data !== '') {
          idMoeda = data.idMoeda;
          // Iso da moeda para a msg de erro se for diferente
          isoMoedaRelatorio = data.codigo_iso;
          entidadeValidacao = data.entidade;
        }
      }
    });
    return idMoeda === null || value == idMoeda;
  }, function () {
    if (entidadeValidacao === 'despesa') {
      return Lang.get('js/src/functions/ValidateForms.same_currency_message', { 'currency': isoMoedaRelatorio })
    }
    return Lang.get('js/src/functions/ValidateForms.same_currency_advance_message', { 'currency': isoMoedaRelatorio })
  });

  /**
   * Validação de data limite para cadastrar despesas no
   * passado, garantindo que o usuário possa gastar despesas
   * com uma data mínima definida
   */
  let messageErrorValidLimitDays = null;

  $.validator.addMethod('limitesData', (value, element) => {
    let success = true;

    const form = element.form;
    const rateiosInput = form.querySelectorAll('[name="idEmpresaReembolsante[]"]');
    const percentualInput = form.querySelectorAll('input[name="rateio[]"]');
    const idDespesa = form.querySelector('input[name="id"]').value;  // Recebe o id da despesa se for editada

    const percentuais = [];
    percentualInput.forEach(percentual => {
      percentuais.push(percentual.value);
    })

    const data = value + ' 00:00:00';
    const rateios = {};

    if (rateiosInput.length) {
      rateiosInput.forEach((currentElement, i) => {
        if (currentElement.value) {
          const idProjeto = currentElement.value;
          const percentual = percentuais[i];

          const rateio = { [idProjeto]: percentual };

          Object.assign(rateios, rateio);
        }
      });
    }

    $.ajax({
      url: route('app.limites-de-despesa.validar-limites-data'),
      method: 'POST',
      data: {
        data: data,
        rateios: rateios,
        despesa: idDespesa,
      },
      async: false,
      error: function (error) {
        success = false;
        messageErrorValidLimitDays = error.responseJSON.message;
      }
    });

    return success;
  }, () => messageErrorValidLimitDays);

  const formSelector = $('form[data-validate], form.js-validate');

  if (formSelector.length) {
    formSelector.each(function (n, el) {
      if (!el.classList.contains('js-validating')) {
        $(el).validate();
        el.classList.add('js-validating');
      }
    });
  }

  /**
   * Validação de número de telefone
   */
  $.validator.addMethod('phoneInternational', function (value, element) {
    const iti = window.intlTelInputGlobals.getInstance(element);
    const countryData = iti.getSelectedCountryData();

    return iti.isValidNumber(value, countryData.dialCode);
  }, Lang.get('js/src/functions/ValidateForms.invalid_phone_number'));

  /**
   * Validação para taxa de câmbio de despesa
   */
  $.validator.addMethod('exchange-value', function (value, element) {
    value = ConversaoCambio.stringToFloat(value);
    return value !== 0
  }, Lang.get('js/src/functions/ValidateForms.exchange_rate_value'));

  /**
   * Validar se o e-mail está sendo utilizado no VExpenses
   * impedindo que ele seja adicionado como uma nova conta ou
   * algo do tipo
   */
  let messageEmailValidation = null;
  $.validator.addMethod('validEmailRegistred', function (value, element) {
    const canUseEmail = false;
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const isValidEmail = regex.test(String(value).toLowerCase());

    if (element.dataset.canBeNull == 'true' && value == '') {
      return true;
    }

    if (!isValidEmail) {
      messageEmailValidation = Lang.get('js/src/functions/ValidateForms.invalid_email');
      return canUseEmail;
    }

    return true;
  }, function () {
    return messageEmailValidation;
  });

  /**
   * Verficiar se a palavra já está cadastrada na tag
   */
  $.validator.addMethod('wordExistInTagList', function (value, element) {
    value = value.toUpperCase();
    const wordElement = document.querySelector(`[data-word-value="${value}"]`);

    return !document.body.contains(wordElement);
  }, Lang.get('js/src/functions/ValidateForms.this_word_already_exist_in_this_tag'));

  /**
   * Verficar se o form de cadastro de membro de equipe está válido
   */
  const $modal = $('.validate-modal')
  const next = $modal.find('#next');
  next.on('click', function (event) {
    const form = $('.validate-form');
    form.validate();
    if (!form.valid()) {
      event.stopImmediatePropagation();
      return;
    };
  })

  /**
   * Verficar se um form está válido
   */
  $(document).on('submit', '.validate-form-submit', function (event) {
    const form = $('.validate-form-submit');
    form.validate();
    if (!form.valid()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    };
  })

  /**
   * Verficar se um form está válido quando o botão for clicado
   */
  $(document).on('click', '.validate-form-button-click', function (event) {
    const form = $('.validate-form-submit');
    form.validate();
    if (!form.valid()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    };
  })

  /**
   * Desativar o botão quando formulário for submetido para evitar duplo clique
   */
  $(document).on('submit', '.avoid-double-click-form', function () {
    $('.submit-button').prop('disabled', true);
  })

  /**
   * Verificar se o email é um email corporativo
   */
  $.validator.addMethod('corporativeEmail', function (value, element) {
    const personalDomains = [
      'gmail.com',
      'hotmail.com',
      'yahoo.com',
      'outlook.com',
      'bol.com.br',
      'uol.com.br',
      'live.com',
      'ig.com.br',
    ];

    const domain = value.split('@')[1];

    const isPersonal = personalDomains.includes(domain)

    if (isPersonal) {
      return false;
    }

    return true;
  }, Lang.get('js/src/functions/ValidateForms.personal_email'));

  /**
   * Válida os dominios digitados (formatação) e garante que o dominio não é proibido (público).
   */
  $.validator.addMethod('emailIsPrivate', function (value, element) {
    function isValidEmailDomain(email) {
      // Aceita uma string com o formato de um dominio sem o @
      // Engloba strings com letras, números, hiféns até 13 caracteres em cada 'setor' dividido por '.'
      const pattern = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$/;
      return pattern.test(email);
    }

    // Mensagem de dominio invalido
    const spanInvalid = document.querySelector('#mensagem-dominio-invalido');
    // Mensagem de dominio gratuíto
    const span = document.querySelector('#mensagem-dominio');
    // Input com os emails
    const emails = document.querySelector('#dominiosEmail');
    // Dominios proíbidos
    const forbiddenEmails = ['gmail.com', 'outlook.com', 'live.com', 'hotmail.com', 'outlook.com.br', 'yahoo.com.br', 'yahoo.com', 'aol.com.br', 'icloud.com', 'email.com', 'email.com.br']
    // Dominios proibidos
    const wrongEmails = [];
    // Emails inválidos
    const invalidEmails = [];

    emails.value.split(';').map((email) => {
      if (email === '') { return; }
      if (forbiddenEmails.includes(email)) {
        wrongEmails.push(email);
      }
      if (!isValidEmailDomain(email)) {
        invalidEmails.push(email);
      }
    })

    // Se existir emails inválidos formata a mensagem exibe e retorna false para a válidação
    if (invalidEmails.length !== 0) {
      // Esconde a mensagem debaixo
      span.classList.add('hidden');

      spanInvalid.classList.remove('hidden');
      emails.classList.add('warning-input');
      document.querySelector('#dominios-invalidos').innerHTML = `(${invalidEmails.length > 3 ? invalidEmails.slice(0, 3).join(',') + ' ...' : invalidEmails.join(',')})`
      return false;
    } else {
      spanInvalid.classList.add('hidden');
      emails.classList.remove('warning-input');
    }

    // Se existir dominíos públicos formata a mensagem e exibe o feedback
    if (wrongEmails.length !== 0) {
      span.classList.remove('hidden');
      emails.classList.add('warning-input');
      document.querySelector('#emails-invalidos').innerHTML = `(${wrongEmails.length > 3 ? wrongEmails.slice(0, 3).join(',') + ' ...' : wrongEmails.join(',')})`
    } else {
      span.classList.add('hidden');
      emails.classList.remove('warning-input');
    }

    return !(wrongEmails.length !== 0);
  }, '');

  /**
   * Válida se o input de cambio do modal ativacao-conciliacao-faturas está vazio e retorna a mensagem
   */
  $.validator.addMethod('cambioDespesaConciliacao', function (value, element) {
    return !!value;
  }, 'Escolha uma forma de câmbio para prosseguir');
}
